import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Returns a function with a stable identity that always calls the latest
 * `callback`. Use it to read current props/state inside an effect without
 * making the effect re-run whenever they change.
 */
export function useStableCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result,
) {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback(
    (...args: Args): Result => callbackRef.current(...args),
    [],
  );
}
